export default __webpack_public_path__ + "static/media/code.ba512726.jpg";